var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('swiper'),_c('application'),_c('plan'),_c('platform'),_c('news')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }